import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { Autocomplete, Popper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import AppAppBar from "./AppAppBar";



const tiers = [
  
  {
    title: "Company Comprehensive Report",
    price: "5100 + GST",
    description: [
      "MCA Details",
      "Complete Financials",
      "Financial Ratios",
      "Ownership Structures",
      "Investments",
      "Other Relevant Financial Items",
      <Typography style={{ fontSize: "16px" }}>Scoring Models :-</Typography>,
      "Altman Z Score",
      "Piotroski F Score",
      "Corporate Governance",
      "Analysis of Company Constitution",
      "Company Operations",
      <Typography style={{ fontSize: "16px" }}>
        Contingent Liabilities and Legal Cases :-
      </Typography>,

      "CIBIL Suits",
      "Debt Recovery Tribunal",
      "National Company Law Tribunal",
      "Court Litigation",
      <Typography style={{ fontSize: "16px" }}>Funding Option :-</Typography>,

      "Equity",
      "Debt",
      "Other Financial Instruments",
      "Company Rating History",
      "Market Trends",
      "Foreign Operations and Hedging Risks",
      "Peer Comparison",
      "Group Experience and Industry Comparison",
      "Group Company Risk",
      "Related Party Transactions",
      "Regulatory Compliance",
      "Negative News",
      <Typography style={{ fontSize: "16px" }}>
        Banking and NBFC Specific Information :-
      </Typography>,

      "Non-Performing Assets",
      "Capital to Risk-weighted Assets Ratio (CRAR)",
      "Loan Book Details",
      "Net Interest Margins",
    ],
    buttonVariant: "outlined",
  },
  {
    title: "Company Risk Profile & Score",
    price: "11000 + GST",
    description: [
      "MCA Details",

      "Complete Financials",

      "Financial Ratios",

      "Ownership Structures",

      "Investments",

      "Other Relevant Financial Items",
      <Typography style={{ fontSize: "16px" }}>Scoring Models :-</Typography>,

      "Altman Z Score",

      "Piotroski F Score",
      <Typography style={{ fontSize: "16px" }}>
        M Score: For detecting earnings manipulation risk :-
      </Typography>,

      "Corporate Governance",

      "Analysis of Company Constitution",

      "Company Operations",

      "Financial Ratio Analysis",

      <Typography style={{ fontSize: "16px" }}>
        Contingent Liabilities and Legal Cases :-
      </Typography>,

      "CIBIL Suits",

      "Debt Recovery Tribunal",

      "National Company Law Tribunal",

      "Court Litigation",

      <Typography style={{ fontSize: "16px" }}>Funding Option :-</Typography>,

      "Equity",

      "Debt",

      "Other Financial Instruments",

      "Company Rating History",

      "Market Trends",

      "Foreign Operations and Hedging Risks",

      "Peer Comparison",

      "Group Experience and Industry Comparison",

      "Group Company Risk",

      "Related Party Transactions",

      "Disputes and Penalties",

      "Corporate Governance Compliance",

      "Regulatory Compliance",

      "Negative News",
      <Typography style={{ fontSize: "16px" }}>
        Banking and NBFC Specific Information :-
      </Typography>,

      "Non-Performing Assets",

      "Capital to Risk-weighted Assets Ratio (CRAR)",

      "Loan Book Details",

      "Net Interest Margins",
    ],
  },
  {
    title: "Company Documents",
    price: "450 + GST",
    description: [
      "Complete company profile",
      "MCA Details",
      "Complete Financials",
      "Financial Ratios",
      "Ownership Structures",
      "Investments",
      "Other Relevant Financial Items",
    ],
    buttonVariant: "outlined",
  },
];

export default function Pricing() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedPrice, setSelectedPrice] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState("");

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = (plan, price) => {
    setSelectedPlan(plan);
    setSelectedPrice(price);
    setOpen(true);
  };

  const handleCheckOut = () => {
    navigate("/checkout", {
      state: { selectedPlan, selectedPrice, selectedCompany },
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [searchValue, setSearchValue] = useState("");
  const [options, setOptions] = useState([]);

  const handleSearch = async (value) => {
    try {
      if (value.length >= 3) {
        const response = await fetch(
          `https://nexensus.club/cbi/company/companySearch?byName=${value}`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        const names = data.map((item) => item.name);
        setOptions(names);
      } else {
        setOptions([]);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
      setOptions([]);
    }
  };

  return (
    <Container
      id="pricing"
      sx={{
        pt: { xs: 4, sm: 6 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 3, sm: 6 },
      }}
    >
      <AppAppBar
        showSubMenu={false}
        showTermsofService={true}
        showContactUs={true}
        showPrivacy={true}
      />

      <Box
        sx={{
          width: "100%",
          textAlign: "center", // Center align the text
        }}
      >
        <Typography
          component="h2"
          variant="h2"
          color="primary.main"
          sx={{ mt: "40px" }}
        >
          Pricing
        </Typography>
        <Typography
          component="h5"
          variant="h5"
          color="primary.main"
          sx={{ mt: "10px" }}
        >
          Customized pricing to suit your needs.
        </Typography>
      </Box>

      <Grid container spacing={3} alignItems="center" justifyContent="center">
        {tiers.map((tier) => (
          <Grid
            item
            key={tier.title}
            xs={12}
            sm={tier.title === "Company Documents" ? 12 : 6}
            md={4}
          >
            <Card
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                gap: 4,
                height: "400px", // Fixed height for the card
                overflow: "hidden",
                border:
                  tier.title === "Company Risk Profile & Score"
                    ? "1px solid"
                    : undefined,
                borderColor:
                  tier.title === "Company Risk Profile & Score"
                    ? "primary.main"
                    : undefined,
                background:
                  tier.title === "Company Risk Profile & Score"
                    ? "linear-gradient(#2F024F, #D49CFC)"
                    : undefined,
              }}
            >
              <CardContent
                sx={{
                  overflowY: "auto", // Enable vertical scrolling
                  maxHeight: "300px", // Maximum height for scrolling content
                }}
              >
                <Box
                  sx={{
                    mb: 1,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color:
                      tier.title === "Company Risk Profile & Score"
                        ? "primary.contrastText"
                        : "",
                  }}
                >
                  <Typography component="h3" variant="h6">
                    {tier.title}
                  </Typography>
                  {tier.title === "Company Risk Profile & Score" && (
                    <Chip
                      icon={<AutoAwesomeIcon />}
                      // label="Recommended"
                      size="small"
                      sx={{
                        backgroundColor: "primary.contrastText",
                        "& .MuiChip-label": {
                          color: "primary.dark",
                        },
                        "& .MuiChip-icon": {
                          color: "primary.dark",
                        },
                      }}
                    />
                  )}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center", // Center the price
                    alignItems: "baseline",
                    color:
                      tier.title === "Company Risk Profile & Score"
                        ? "primary.contrastText"
                        : "",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "2rem", // Consistent font size for all prices
                    }}
                  >
                    {tier.price}
                  </Typography>
                </Box>
                <Divider />
                <Typography
                  component="div" // Change to "div" to avoid list styling
                  variant="body2"
                  sx={{
                    pl: 4,
                    color:
                      tier.title === "Company Risk Profile & Score"
                        ? "primary.contrastText"
                        : "",
                  }}
                >
                  <ul>
                    {tier.description.map((line) => {
                      if (typeof line === "string") return <li>{line}</li>;
                      else {
                        return line;
                      }
                    })}
                  </ul>
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  variant={tier.buttonVariant}
                  onClick={() => handleClickOpen(tier.title, tier.price)}
                  sx={{
                    marginX: "auto",
                    height: "100%",
                    width: "200%",
                  }}
                >
                  Buy
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        fullScreen={fullScreen}
      >
        <DialogTitle>{selectedPlan}</DialogTitle>
        <DialogContent>
          <Autocomplete
            freeSolo
            options={options}
            onInputChange={(event, value) => {
              setSearchValue(value);
              handleSearch(value);
            }}
            onChange={(event, value) => {
              setSelectedCompany(value); // Set the selected company here
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search Company"
                variant="outlined"
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  handleSearch(e.target.value);
                }}
              />
            )}
            PopperComponent={(props) => <Popper {...props} />}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={handleCheckOut}
            disabled={!selectedCompany}
            variant="contained"
          >
            Proceed to Checkout
          </Button>
        </DialogActions>
      </Dialog>
      <Button
      variant="contained"
      color="primary"
      href="tel: +91-11-47542465" // Replace with the actual phone number
      sx={{ textTransform: 'none' }} // Prevents all-uppercase text
    >
      Call For Best Offers
    </Button>
      <Footer />
    </Container>
  );
}
